import { Outlet } from "react-router-dom";
import AuthCheck from "./AuthCheck"
const loginLayout = () => {
    return (
        <AuthCheck>
            <Outlet />
        </AuthCheck>
    );
};
export default loginLayout;